import axios, { AxiosPromise } from 'axios';

import { ICountry } from '../../../@types/model/masterData/country/country';
import { ICountryUpsert } from '../../../@types/model/masterData/country/countryUpsert';

export default class CountryHttpService {
    public static getCountryData() : AxiosPromise<Array<ICountry>> {
        return axios.get(`${API_URL}/v1/Country/GetAllWeb`);
    }

    public static addOrUpdateCountry(upsert : ICountryUpsert) : AxiosPromise<ICountry> {
        return axios.post(`${API_URL}/v1/Country/PostCountry`, upsert);
    }

    public static deleteCountry(countryId : number) : AxiosPromise<ICountry> {
        return axios.delete(`${API_URL}/v1/Country/Delete`, {
            params : { countryId },
        });
    }
}
